import React, { useState, useEffect } from "react";

import { toast } from "react-toastify";
import { Grid, Container, Dialog, DialogContent, DialogActions, TextField, Input } from "@material-ui/core/";
import { MuiPickersUtilsProvider, KeyboardTimePicker, KeyboardDatePicker } from "@material-ui/pickers";
import InputMask from "react-input-mask";

import { format, parseISO } from "date-fns";

import Label from "../../components/Label";
import Button from "../../components/Button";
import Description from "../../components/Description";

import EventApi from "../../services/event";

import {
    Content,
    Row,
    LogoName,
    Header,
    Body,
    Align,
    TermsField,
    CheckboxContainer,
    CheckboxLabel,
    StyledInput,
} from "./styles";
import Terms from "../../components/Terms";
import eventLogo from "../../assets/images/FazendoMaisLogo.png";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";

const SubscribeToEvent = (props) => {
    const [event, setEvent] = useState({});
    const [personData, setPersonData] = useState({
        name: "",
        email: "",
        phone: "",
        certificate: 0,
        enable: true,
        vip: false,
        status_id: 1,
        solicitation_approved: false,
        is_guest: false,
        company: "",
        role: "",
        gender: "",
        cpf: "",
    });
    const [state, setState] = useState(true);
    const [formState, setFormState] = useState(false);
    const [person, setPerson] = useState({});
    const [status, setStatus] = useState([{}]);
    const [confirmEmail, setConfirmEmail] = useState("");

    const [acceptedTerms, setAcceptedTerms] = useState(true);
    const [acceptedCenpComunication, setAcceptedCenpComunication] = useState(true);
    const [acceptedPartnersComunication, setAcceptedPartnersComunication] = useState(true);
    const [open, setOpen] = useState(false);

    const defaultEventId = 1;

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function onChange(event) {
        const { value, name } = event.target;
        setPersonData({
            ...personData,
            [name]: value,
        });
    }

    const handleChangeDate = (date) => {
        setPersonData({ ...personData, birth: date });
    };

    const validFormFields = () => {
        let isValid = true;
        const errors = [];
        Object.entries(personData).forEach(([key, value]) => {
            if (key === "name") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira o nome completo");
                } else if (value.length < 3) {
                    isValid = false;
                    errors.push("Insira o nome completo");
                }
            }
            if (key === "email") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira um endereço de email");
                } else if (value.length < 3) {
                    isValid = false;
                    errors.push("Insira um endereço de email válido");
                } else if (value !== confirmEmail) {
                    isValid = false;
                    errors.push("Os emails são diferentes");
                }
            }
            if (key === "phone") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira um numero para contato");
                }
            }
            if (key === "company") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira uma instituição");
                }
            }
            if (key === "cpf") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira seu CPF ou Passaporte");
                }
            }
            // if (key === "birth") {
            //     if (value === "" || !value) {
            //         isValid = false;
            //         errors.push("Insira a data de nascimento");
            //     }
            // }
        });
        if (errors && errors.length) errors.map((e) => toast.warn(e));
        return isValid;
    };

    const formatData = () => {
        return {
            ...personData,
            phone: personData.phone ? personData.phone.match(/\d/g).join("") : null,
            event_id: `${event.id}`,
            accepted_terms: acceptedTerms,
            allow_marketing: acceptedCenpComunication,
        };
    };

    const handleSubscribe = async () => {
        // if (!acceptedTerms) {
        //     toast.warn("É necessário aceitar os termos de uso de dados e imagens");
        //     return;
        // }

        try {
            if (validFormFields()) {
                const formatedData = formatData();
                const createPersonResult = await EventApi.createPerson({
                    ...formatedData,
                });
                if (createPersonResult && createPersonResult.data) {
                    setFormState(true);
                    toast.success("Inscrição realizada!");
                } else if (createPersonResult?.response?.data?.message?.includes("Already used")) {
                    if (createPersonResult?.response?.data?.message?.includes("email"))
                        toast.error("O email inserido já foi cadastrado");
                    if (createPersonResult?.response?.data?.message?.includes("cpf"))
                        toast.error("O CPF inserido já foi cadastrado");
                } else toast.error("Ocorreu um erro.\nEntre em contato com a organização");
            }
        } catch (error) {
            console.log(error);
            toast.error(`Ocorreu um erro. ${JSON.stringify(error)}\nEntre em contato com a organização`);
        }
    };

    useEffect(() => {
        async function getData() {
            const respEvent = await EventApi.getEvent(props.match.params.event_id || defaultEventId);
            if (!!respEvent.data) {
                setEvent(respEvent.data.data);
                EventApi.getStatus()
                    .then((respStatus) => {
                        if (!!respStatus.data) {
                            setStatus(respStatus.data.data);
                        }
                    })
                    .catch(function (error) {
                        toast.error(error);
                    });
            } else {
                toast.error("Evento não encontrado");
                setState(false);
            }
        }

        getData();
    }, []);

    const success = (
        <>
            <Grid container direction="column" justifyContent="center" alignItems="center">
                <Label size="big" color="white" align="center" font="Roboto" padding="10px 0 30px">
                    Inscrição Realizada!
                </Label>
                <Label size="small" color="white" align="center" font="Roboto" padding="10px 0 30px">
                    Aguarde sua confirmação por email
                </Label>
                <Label size="small" color="white" align="center" font="Roboto" padding="10px 0 30px">
                    Obrigado!
                </Label>
            </Grid>
        </>
    );
    const eventNotFound = (
        <Label size="big" color="white" align="center" font="Roboto" padding="10px 0 30px">
            Evento não encontrado
        </Label>
    );
    const formConfirm = (
        <>
            <Label size="min" color="white" align="center" font="Roboto" padding="10px 0 30px">
                Faça sua inscrição no nosso evento!
            </Label>
            <TextField
                key="name"
                name="name"
                label="Digite seu nome completo"
                required
                fullWidth
                value={personData.name}
                onChange={onChange}
                inputProps={{
                    maxLength: 255,
                    style: {
                        color: "white",
                    },
                }}
                InputLabelProps={{
                    style: {
                        color: "rgb(255,255,255,0.54)",
                    },
                }}
            />
            <InputMask
                mask="999.999.999-99"
                value={personData.cpf}
                onChange={onChange}
                disabled={false}
                maskChar=""
                type="text"
                name="cpf"
                required
            >
                {() => (
                    <TextField
                        key="cpf"
                        name="cpf"
                        label="Digite seu CPF"
                        required
                        fullWidth
                        value={personData.cpf}
                        onChange={onChange}
                        inputProps={{
                            style: {
                                color: "white",
                            },
                        }}
                        InputLabelProps={{
                            style: {
                                color: "rgb(255,255,255,0.54)",
                            },
                        }}
                    />
                )}
            </InputMask>

            <TextField
                key="company"
                name="company"
                label="Órgão/Instituição"
                required
                fullWidth
                value={personData.company}
                onChange={onChange}
                inputProps={{
                    maxLength: 255,
                    style: {
                        color: "white",
                    },
                }}
                InputLabelProps={{
                    style: {
                        color: "rgb(255,255,255,0.54)",
                    },
                }}
            />
            <TextField
                key="email"
                name="email"
                label="Digite seu email"
                required
                fullWidth
                value={personData.email}
                onChange={onChange}
                inputProps={{
                    maxLength: 255,
                    style: {
                        color: "white",
                    },
                }}
                InputLabelProps={{
                    style: {
                        color: "rgb(255,255,255,0.54)",
                    },
                }}
            />
            <TextField
                key="confirm_email"
                name="confirm_email"
                label="Confirme seu email"
                required
                fullWidth
                value={confirmEmail}
                onChange={(e) => {
                    e.preventDefault();
                    setConfirmEmail(e.target.value);
                }}
                error={confirmEmail !== personData.email}
                type="email"
                onPaste={(e) => {
                    e.preventDefault();
                    return false;
                }}
                inputProps={{
                    maxLength: 255,
                    style: {
                        color: "white",
                    },
                }}
                InputLabelProps={{
                    style: {
                        color: "rgb(255,255,255,0.54)",
                    },
                }}
            />
            <InputMask
                mask="+55 (99) 9 9999-9999"
                value={personData.phone}
                onChange={onChange}
                disabled={false}
                maskChar=""
                type="text"
                name="phone"
                required
                color="#fefefe"
            >
                {() => (
                    <TextField
                        key="phone"
                        name="phone"
                        label="Digite um telefone para contato"
                        fullWidth
                        value={personData.phone}
                        onChange={onChange}
                        required
                        InputLabelProps={{
                            style: {
                                color: "rgb(255,255,255,0.54)",
                            },
                        }}
                        inputProps={{
                            style: {
                                color: "white",
                            },
                        }}
                    />
                )}
            </InputMask>

            {/* <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                <KeyboardDatePicker
                    disableFuture
                    animateYearScrolling
                    title="Data de nascimento"
                    translate="yes"
                    maxDate={new Date()}
                    // disableToolbar
                    variant="inline"
                    format="dd-MM-yyyy"
                    margin="normal"
                    name="birth"
                    label="Data de nascimento"
                    value={personData.birth}
                    onChange={handleChangeDate}
                    fullWidth
                    KeyboardButtonProps={{
                        "aria-label": "change date",
                    }}
                    inputProps={{
                        style: {
                            color: "white",
                        },
                    }}
                    InputLabelProps={{
                        style: {
                            color: "rgb(255,255,255,0.54)",
                        },
                    }}
                />
            </MuiPickersUtilsProvider> */}

            <Button size="nano" color="success" format="solid" width="100%" margin="20px 0" onClick={handleSubscribe}>
                Inscrever
            </Button>

            {/* <TermsField>
                <div>
                    <input
                        type="checkbox"
                        checked={acceptedTerms}
                        onChange={(e) => {
                            setAcceptedTerms(e.target.checked);
                            if (!e.target.checked)
                                toast.warn("É necessário aceitar os termos de uso de dados e imagens");
                        }}
                    />
                    <p>
                        Declaro que concordo com os{" "}
                        <span onClick={() => handleClickOpen(true)}>
                            Termos de Uso de dados e imagem e Política de Privacidade
                        </span>
                    </p>
                </div> */}
            {/* <div>
                <input type="checkbox" checked={acceptedCenpComunication} onChange={(e) => setAcceptedCenpComunication(e.target.checked)} />
                <p>Declaro que aceito receber comunicações do Cenp</p>
            </div>
            <div>
                <input type="checkbox" checked={acceptedPartnersComunication} onChange={(e) => setAcceptedPartnersComunication(e.target.checked)} />
                <p>Declaro que aceito receber comunicações de parceiros do Cenp</p>
            </div> */}
            {/* </TermsField> */}

            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
                <DialogContent>
                    <Terms />
                </DialogContent>
                <DialogActions>
                    <Button size="nano" color="dark" format="solid" width="100%" margin="20px 0" onClick={handleClose}>
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );

    const defaultForm = (
        <>
            <Grid container justify="space-around" spacing={8}>
                <Grid item md={6}>
                    {/* <Label
                    size='big'
                    color='dark'
                    align='center'
                    font='Roboto'
                    padding='10px 0 30px'
                >{event.name}</Label> */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "20px",
                        }}
                    >
                        <img style={{ maxHeight: "300px", maxWidth: "300px" }} src={eventLogo} alt="Logo" />
                    </div>
                    <Description color="white" name="Data: " value="24 e 25 de Setembro" />
                    <Align>
                        <Label size="nano" color="white" align="left" weight="700" padding="5px 0">
                            Endereço:
                        </Label>
                        <Label size="nano" color="white" align="left" padding="5px 0">
                            {event.address}
                        </Label>
                    </Align>
                    <Label size="min" color="white" weight="100" font="Roboto" padding="50px 0">
                        {/* {event.description} */}Evento Demo
                    </Label>
                </Grid>
                <Grid className="border" item md={6}>
                    {formState ? success : formConfirm}
                    {/* <Grid container direction="column" justifyContent="center" alignItems="center">
                        <Label size="big" color="white" align="center" font="Roboto" padding="10px 0 30px">
                            Inscrições encerradas!
                        </Label>
                        <Label size="small" color="white" align="center" font="Roboto" padding="10px 0 30px">
                            Obrigado!
                        </Label>
                    </Grid> */}
                </Grid>
            </Grid>
        </>
    );

    return (
        <>
            <Header>{event && <LogoName>{event.name}</LogoName>}</Header>
            <Body>
                <Container maxWidth="md">
                    <Content>
                        <Row>
                            <Container className="container" maxWidth="md">
                                {state ? defaultForm : eventNotFound}
                            </Container>
                        </Row>
                    </Content>
                </Container>
            </Body>
        </>
    );
};

export default SubscribeToEvent;
